export const statsData = [
  { id: 'stat-1', value: '1,500+', label: '期开奖数据', icon: 'ri-database-2-line' },
  { id: 'stat-2', value: '49', label: '个号码全覆盖', icon: 'ri-numbers-line' },
  { id: 'stat-3', value: '6', label: '大分类知识库', icon: 'ri-stack-line' },
  { id: 'stat-4', value: '100+', label: '篇专业文章', icon: 'ri-article-line' },
];

export const faqData = [
  {
    id: 'faq-1',
    question: '六合宝典是什么？',
    answer: '六合宝典是一个专业的六合彩信息参考平台，提供完整的玩法规则解析、历史数据分析、号码走势图表及专业解读，帮助玩家系统掌握规律、理性参考。',
  },
  {
    id: 'faq-2',
    question: '六合宝典的数据是否准确？',
    answer: '我们的数据来源于官方开奖记录，经过多重校验确保准确性。历史数据实时同步更新，所有分析图表均基于真实数据生成。',
  },
  {
    id: 'faq-3',
    question: '如何使用号码走势图？',
    answer: '号码走势图展示每个号码在不同期数中的出现情况。您可以通过观察冷热号分布、遗漏值变化和区间趋势来进行分析。我们提供详细的使用指南帮助您快速上手。',
  },
  {
    id: 'faq-4',
    question: '六合宝典是否保证中奖？',
    answer: '六合宝典是一个信息参考工具，所有分析数据仅供参考。彩票开奖具有随机性，过往数据不能保证未来结果。我们倡导理性娱乐，请勿沉迷。',
  },
  {
    id: 'faq-5',
    question: '六合宝典的信息是否免费？',
    answer: '六合宝典的核心内容完全免费开放，包括玩法解析、历史数据查询、走势图查看等。我们致力于为所有玩家提供便捷的参考服务。',
  },
  {
    id: 'faq-6',
    question: '如何获取最新的开奖结果？',
    answer: '最新开奖结果会在官方公布后第一时间更新。您可以直接访问本站开奖记录页面，或关注首页推荐区域获取最新信息。',
  },
];